export default __webpack_public_path__ + "static/web-development-3312474a2a3d016267d8cdee25090a09.webp";